// import CloneTrait from './CloneTrait';

export default class NumberFormatter {

    static decimalDelimiter = null;
    static DEFAULT_DECIMAL_DELIMITER = ',';

    constructor(value, currency = null){

        // new CloneTrait(this);

        this.value = value;
        this.currency = currency;
    }

    clone() {

        return new NumberFormatter(this.value, this.currency);
    }

    static parse(value, defaultValue = null, forceSuffix = null, forceDecimalDelimiter = null) {

        if (typeof (value) == 'number')
            return new NumberFormatter(value, forceSuffix);

        if (value instanceof (NumberFormatter))
            return new NumberFormatter(value.value, forceSuffix ?? value.currency);

        let
            normalizedValue = (new String(value)).trim().replace(/\s/g, ''),
            suffix = forceSuffix;

        if (!normalizedValue.match(/\d/))
            return new NumberFormatter(defaultValue, forceSuffix);
        // not number

        if (!suffix) {

            const matchSuffix = normalizedValue.match(/\d(?<suffix>[^\.\,\d]+)$/);
            if (matchSuffix && matchSuffix.length)
                suffix = matchSuffix.groups.suffix;
        }

        const
            decimalDelimiter = forceDecimalDelimiter ?? NumberFormatter.getDecimalDelimiter(),
            decimalRegExp = new RegExp(`(?<number>.+)\\${decimalDelimiter}(?<decimal>\\d+)`),
            matchValue = normalizedValue.match(decimalRegExp);

        normalizedValue = (matchValue && matchValue.length)
            ? `${matchValue.groups.number.replace(/[^\d]/g, '')}.${matchValue.groups.decimal}`
            : normalizedValue.replace(/[^\d]/g, '');
        
        return new NumberFormatter(parseFloat(normalizedValue), suffix);
    }

    static parseEx(value, options = {}) {

        if (options?.allowReturnNull && (value === null || value === undefined || value === ''))
            return null;

        return NumberFormatter.parse(value,
            options?.defaultValue,
            options?.currency,
            options?.decimalDelimiter);
    }

    setSuffix(suffix) {

        this.currency = suffix;
        return this;
    }

    plus(number) {

        if (number instanceof NumberFormatter) {

            this.value+= number.value;
            return this;
        }

        const value = parseFloat(number);
        if (!Number.isNaN(value)) {

            this.value+= value;
            return this;
        }

        throw new Error(`Unknown number format: ${number}`);
    }

    minus(number) {

        if (number instanceof NumberFormatter) {

            this.value-= number.value;
            return this;
        }

        const value = parseFloat(number);
        if (!Number.isNaN(value)) {

            this.value-= value;
            return this;
        }

        throw new Error(`Unknown number format: ${number}`);
    }

    multiple(number) {

        if (number instanceof NumberFormatter) {

            this.value*= number.value;
            return this;
        }

        const value = parseFloat(number);
        if (!Number.isNaN(value)) {

            this.value*= value;
            return this;
        }

        throw new Error(`Unknown number format: ${number}`);
    }

    div(number) {

        if (number instanceof NumberFormatter) {

            this.value/= number.value;
            return this;
        }

        const value = NumberFormatter.parse(number).toFloat();
        if (!Number.isNaN(value)) {

            this.value/= value;
            return this;
        }

        throw new Error(`Unknown number format: ${number}`);
    }

    eq(value) {

        const number = NumberFormatter.parse(value);
        return this.toFloat() === number.toFloat();
    }

    toInt() {

        return parseInt(this.value);
    }

    toFloat() {

        return parseFloat(this.value);
    }

    set(value) {
        
        this.value = NumberFormatter.parse(value).toFloat();
        return this;
    }

    round() {

        this.value = Math.round(this.value);

        return this;
    }

    formatted() {

        if (!this.formatter) {

            const options = {
                minimumFractionDigits: Math.round(this.value) != this.value ? 2 : 0,
                maximumFractionDigits: 2,
            };

            if (this.currency?.iso) {
                
                options['style'] = 'currency';
                options['currency'] = this.currency.iso;
                options['currencyDisplay'] = 'symbol';
            }

            this.formatter = new Intl.NumberFormat(NumberFormatter.getLocale(), options);
        }

        const value = this.formatter.format(this.value);

        if (this.currency && !this.currency?.iso)
            return `${value} ${this.currency}`;

        return value;
    }

    static getLocale() {

        if (navigator.languages != undefined) 
            return navigator.languages[0];
        
        return navigator.language;
    }

    static getDecimalDelimiter() {

        if (!NumberFormatter.decimalDelimiter) {

            const string = parseFloat('1.1').toLocaleString(NumberFormatter.getLocale());
            NumberFormatter.decimalDelimiter = string[1];
        }
        
        return NumberFormatter.decimalDelimiter;
    }
}